module.exports = __webpack_public_path__ + "static/images/logo-v2.OHdiDo3.svg";